import AutoCreatedTag from "app/pages/sales-intelligence/sub-modules/opportunities/components/list-items/AutoCreatedTag/AutoCreatedTag";
import { OpportunityListTypeEnum } from "app/pages/sales-intelligence/sub-modules/opportunities/types";
import type { ReactNode } from "react";
import type { ListItemDto } from "../../types/dto";

export const getListTag = ({ listType }: ListItemDto): ReactNode => {
    switch (listType) {
        case OpportunityListTypeEnum.Crm:
        case OpportunityListTypeEnum.RecentlyViewed:
            return <AutoCreatedTag isSmall />;

        default:
            return null;
    }
};
